/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as ChromeRouteRouteImport } from "./routes/_chrome/route"
import { Route as ErrorRouteImport } from "./routes/error"
import { Route as ChromeIndexRouteImport } from "./routes/_chrome/index"
import { Route as ChromeAiAgentsIndexRouteImport } from "./routes/_chrome/ai-agents/index"
import { Route as ChromeConversationsIndexRouteImport } from "./routes/_chrome/conversations/index"
import { Route as ChromeConversationsFooRouteImport } from "./routes/_chrome/conversations/foo"
import { Route as ChromeDataIndexRouteImport } from "./routes/_chrome/data/index"
import { Route as ChromeInsightsIndexRouteImport } from "./routes/_chrome/insights/index"
import { Route as ChromeKnowledgebaseIndexRouteImport } from "./routes/_chrome/knowledgebase/index"
import { Route as ChromeSuperpowersErrorsIndexRouteImport } from "./routes/_chrome/superpowers/errors/index"

const ChromeRouteRoute = ChromeRouteRouteImport.update({
  id: "/_chrome",
  getParentRoute: () => rootRouteImport,
} as any)
const ErrorRoute = ErrorRouteImport.update({
  id: "/error",
  path: "/error",
  getParentRoute: () => rootRouteImport,
} as any)
const ChromeIndexRoute = ChromeIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => ChromeRouteRoute,
} as any)
const ChromeAiAgentsIndexRoute = ChromeAiAgentsIndexRouteImport.update({
  id: "/ai-agents/",
  path: "/ai-agents/",
  getParentRoute: () => ChromeRouteRoute,
} as any)
const ChromeConversationsIndexRoute =
  ChromeConversationsIndexRouteImport.update({
    id: "/conversations/",
    path: "/conversations/",
    getParentRoute: () => ChromeRouteRoute,
  } as any)
const ChromeConversationsFooRoute = ChromeConversationsFooRouteImport.update({
  id: "/conversations/foo",
  path: "/conversations/foo",
  getParentRoute: () => ChromeRouteRoute,
} as any)
const ChromeDataIndexRoute = ChromeDataIndexRouteImport.update({
  id: "/data/",
  path: "/data/",
  getParentRoute: () => ChromeRouteRoute,
} as any)
const ChromeInsightsIndexRoute = ChromeInsightsIndexRouteImport.update({
  id: "/insights/",
  path: "/insights/",
  getParentRoute: () => ChromeRouteRoute,
} as any)
const ChromeKnowledgebaseIndexRoute =
  ChromeKnowledgebaseIndexRouteImport.update({
    id: "/knowledgebase/",
    path: "/knowledgebase/",
    getParentRoute: () => ChromeRouteRoute,
  } as any)
const ChromeSuperpowersErrorsIndexRoute =
  ChromeSuperpowersErrorsIndexRouteImport.update({
    id: "/superpowers/errors/",
    path: "/superpowers/errors/",
    getParentRoute: () => ChromeRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof ChromeIndexRoute
  "/error": typeof ErrorRoute
  "/conversations/foo": typeof ChromeConversationsFooRoute
  "/ai-agents/": typeof ChromeAiAgentsIndexRoute
  "/conversations/": typeof ChromeConversationsIndexRoute
  "/data/": typeof ChromeDataIndexRoute
  "/insights/": typeof ChromeInsightsIndexRoute
  "/knowledgebase/": typeof ChromeKnowledgebaseIndexRoute
  "/superpowers/errors/": typeof ChromeSuperpowersErrorsIndexRoute
}
export interface FileRoutesByTo {
  "/error": typeof ErrorRoute
  "/": typeof ChromeIndexRoute
  "/conversations/foo": typeof ChromeConversationsFooRoute
  "/ai-agents": typeof ChromeAiAgentsIndexRoute
  "/conversations": typeof ChromeConversationsIndexRoute
  "/data": typeof ChromeDataIndexRoute
  "/insights": typeof ChromeInsightsIndexRoute
  "/knowledgebase": typeof ChromeKnowledgebaseIndexRoute
  "/superpowers/errors": typeof ChromeSuperpowersErrorsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_chrome": typeof ChromeRouteRouteWithChildren
  "/error": typeof ErrorRoute
  "/_chrome/": typeof ChromeIndexRoute
  "/_chrome/conversations/foo": typeof ChromeConversationsFooRoute
  "/_chrome/ai-agents/": typeof ChromeAiAgentsIndexRoute
  "/_chrome/conversations/": typeof ChromeConversationsIndexRoute
  "/_chrome/data/": typeof ChromeDataIndexRoute
  "/_chrome/insights/": typeof ChromeInsightsIndexRoute
  "/_chrome/knowledgebase/": typeof ChromeKnowledgebaseIndexRoute
  "/_chrome/superpowers/errors/": typeof ChromeSuperpowersErrorsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/error"
    | "/conversations/foo"
    | "/ai-agents/"
    | "/conversations/"
    | "/data/"
    | "/insights/"
    | "/knowledgebase/"
    | "/superpowers/errors/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/error"
    | "/"
    | "/conversations/foo"
    | "/ai-agents"
    | "/conversations"
    | "/data"
    | "/insights"
    | "/knowledgebase"
    | "/superpowers/errors"
  id:
    | "__root__"
    | "/_chrome"
    | "/error"
    | "/_chrome/"
    | "/_chrome/conversations/foo"
    | "/_chrome/ai-agents/"
    | "/_chrome/conversations/"
    | "/_chrome/data/"
    | "/_chrome/insights/"
    | "/_chrome/knowledgebase/"
    | "/_chrome/superpowers/errors/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ChromeRouteRoute: typeof ChromeRouteRouteWithChildren
  ErrorRoute: typeof ErrorRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_chrome": {
      id: "/_chrome"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof ChromeRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/error": {
      id: "/error"
      path: "/error"
      fullPath: "/error"
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_chrome/": {
      id: "/_chrome/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof ChromeIndexRouteImport
      parentRoute: typeof ChromeRouteRoute
    }
    "/_chrome/ai-agents/": {
      id: "/_chrome/ai-agents/"
      path: "/ai-agents"
      fullPath: "/ai-agents/"
      preLoaderRoute: typeof ChromeAiAgentsIndexRouteImport
      parentRoute: typeof ChromeRouteRoute
    }
    "/_chrome/conversations/": {
      id: "/_chrome/conversations/"
      path: "/conversations"
      fullPath: "/conversations/"
      preLoaderRoute: typeof ChromeConversationsIndexRouteImport
      parentRoute: typeof ChromeRouteRoute
    }
    "/_chrome/conversations/foo": {
      id: "/_chrome/conversations/foo"
      path: "/conversations/foo"
      fullPath: "/conversations/foo"
      preLoaderRoute: typeof ChromeConversationsFooRouteImport
      parentRoute: typeof ChromeRouteRoute
    }
    "/_chrome/data/": {
      id: "/_chrome/data/"
      path: "/data"
      fullPath: "/data/"
      preLoaderRoute: typeof ChromeDataIndexRouteImport
      parentRoute: typeof ChromeRouteRoute
    }
    "/_chrome/insights/": {
      id: "/_chrome/insights/"
      path: "/insights"
      fullPath: "/insights/"
      preLoaderRoute: typeof ChromeInsightsIndexRouteImport
      parentRoute: typeof ChromeRouteRoute
    }
    "/_chrome/knowledgebase/": {
      id: "/_chrome/knowledgebase/"
      path: "/knowledgebase"
      fullPath: "/knowledgebase/"
      preLoaderRoute: typeof ChromeKnowledgebaseIndexRouteImport
      parentRoute: typeof ChromeRouteRoute
    }
    "/_chrome/superpowers/errors/": {
      id: "/_chrome/superpowers/errors/"
      path: "/superpowers/errors"
      fullPath: "/superpowers/errors/"
      preLoaderRoute: typeof ChromeSuperpowersErrorsIndexRouteImport
      parentRoute: typeof ChromeRouteRoute
    }
  }
}

interface ChromeRouteRouteChildren {
  ChromeIndexRoute: typeof ChromeIndexRoute
  ChromeConversationsFooRoute: typeof ChromeConversationsFooRoute
  ChromeAiAgentsIndexRoute: typeof ChromeAiAgentsIndexRoute
  ChromeConversationsIndexRoute: typeof ChromeConversationsIndexRoute
  ChromeDataIndexRoute: typeof ChromeDataIndexRoute
  ChromeInsightsIndexRoute: typeof ChromeInsightsIndexRoute
  ChromeKnowledgebaseIndexRoute: typeof ChromeKnowledgebaseIndexRoute
  ChromeSuperpowersErrorsIndexRoute: typeof ChromeSuperpowersErrorsIndexRoute
}

const ChromeRouteRouteChildren: ChromeRouteRouteChildren = {
  ChromeIndexRoute: ChromeIndexRoute,
  ChromeConversationsFooRoute: ChromeConversationsFooRoute,
  ChromeAiAgentsIndexRoute: ChromeAiAgentsIndexRoute,
  ChromeConversationsIndexRoute: ChromeConversationsIndexRoute,
  ChromeDataIndexRoute: ChromeDataIndexRoute,
  ChromeInsightsIndexRoute: ChromeInsightsIndexRoute,
  ChromeKnowledgebaseIndexRoute: ChromeKnowledgebaseIndexRoute,
  ChromeSuperpowersErrorsIndexRoute: ChromeSuperpowersErrorsIndexRoute,
}

const ChromeRouteRouteWithChildren = ChromeRouteRoute._addFileChildren(
  ChromeRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  ChromeRouteRoute: ChromeRouteRouteWithChildren,
  ErrorRoute: ErrorRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
